var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-user-like-button",style:({  width: _vm.width, height: _vm.height }),on:{"touchend":function($event){$event.stopPropagation();return _vm.$emit('like-button-clicked')}}},[(_vm.isProcessing)?_c('LoadingHeart'):(_vm.liked)?_c('b-icon',{attrs:{"icon":'heart-fill',"aria-hidden":"true","dark":""}}):_c('IconEmptyHeart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }